import { IMspStatusData } from '../interfaces/msp-statuses-map';

export type MspStatusesMap = Map<string, IMspStatusData>;

export const pendingTriageStatuses = ['New', 'Information'] as const;
